<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" lg="10" md="10" sm="12">
        <div style="">
          <v-overlay absolute :value="overlay">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
          </v-overlay>
          <div class="mb-4">
<!--            <TopBanner :seller="sellerproduct"/>-->
                      <v-card>
                        <div class="label-buka white--text">
                          <div :class="sellerproduct.statustoko===1?'box2':'box1'"><h3>{{tokostatustext(sellerproduct.statustoko)}}</h3></div>
                        </div>
                        <div class="label-online white--text">
                          <div :class="sellerproduct.online===1?'boxonline':'boxoffline'">{{onlinestatus(sellerproduct.online)}}</div>
                        </div>
                        <v-card-text class="profile text-center align-content-center align-center">
                          <div class="" style=";margin: auto;width: 100%">
                            <img class="logo-seller" v-if="sellerproduct.avatar" alt="logo" width="150px" style="" :src="sellerproduct.avatar"/>
                            <img v-else alt="logo" width="150px" style=" background-color: white;padding: 8px;border-radius: 20px" src="../assets/logoirsmarket.png"/>
                            <div class="white--text"><h2>{{sellerproduct.membername}}</h2></div>
                            <div class="white--text">{{sellerproduct.cities.cityname}},{{sellerproduct.province.provincename}}</div>
                            <div class="white--text">{{sellerproduct.contact}}</div>
                          </div>
                        </v-card-text>
                        <v-card-actions class="text-center align-content-center align-center">
                          <div class="row text-center align-center align-content-center" style="height: 50px;width: 100%">
<!--                            <div class="text-center ma-4">Bergabung sejak : {{formatDate(sellerproduct.registertime)}}</div>-->
                            <div class="ml-2" style="display: flex"><v-rating :value="sellerproduct.rating" color="accent" dense readonly size="20"></v-rating><div class="ml-2" style="font-size: 14px;margin-top: 4px">{{totalreview}} Ulasan</div></div>
                            <v-btn icon @click="openchat(sellerproduct)" text><v-icon>chat</v-icon></v-btn>
                            <v-spacer/>
                            <div class="text-center mr-4">Terakhir Aktif : {{formatDate(sellerproduct.lastactive)}}</div>
                          </div>
                        </v-card-actions>
                      </v-card>
          </div>
          <v-tabs  v-model="tab">
            <v-tab><v-badge color="green" :content="sellerproduct.productlist.length">Produk</v-badge></v-tab>
            <v-tab><v-badge color="green" :content="totalreview">Ulasan</v-badge></v-tab>
            <v-tab-item>
              <div class="mt-4">
                <div v-for="(item, index) in sellerproduct.productlist"  :key="index">
                  <div><h2>{{item.categoryname}}</h2></div>
                  <div v-for="(itemb, index) in item.brands"  :key="index">
                    <v-img width="50px" :src="itemb.brandlogo"></v-img>
                    <TableProductSeller :products="itemb.products"></TableProductSeller>
                  </div>
                </div>
              </div>
            </v-tab-item>
            <v-tab-item>
              <SellerReview/>
            </v-tab-item>
          </v-tabs>
        </div>
      </v-col>
    </v-row>
    </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import TableProductSeller from '@/components/TableProductSeller'
import moment from 'moment'
import SellerReview from '@/components/SellerReview'

export default {
  name: 'SellerPage',
  components: { SellerReview, TableProductSeller },
  data: () => ({
    tab: null
  }),
  mounted () {
    this.clearsellerproduct()
    setTimeout(function () {
      this.getData()
    }.bind(this, 500))
  },
  activated () {
  },
  computed: {
    ...mapState('ProductStore', ['sellerproduct', 'overlay']),
    ...mapState('ReviewStore', ['reviews', 'totalreview'])
  },
  beforeDestroy () {
    this.clearsellerproduct()
  },
  methods: {
    ...mapActions('ProductStore', ['getSellerProducts', 'clearsellerproduct']),
    ...mapActions('ReviewStore', ['getReviews']),
    ...mapActions('ChatStore', ['setToUser', 'setdialog']),
    openchat (seller) {
      this.setToUser({ memberid: this.$route.params.id, membername: seller.membername, avatar: seller.avatar })
      this.setdialog(true)
    },
    getData () {
      this.getSellerProducts(this.$route.params.id)
      this.getReviews({ memberid: this.$route.params.id })
    },
    formatDate (value) {
      return moment(value).add(0, 'hours').format('YYYY/MM/DD HH:mm:ss')
    },
    onlinestatus (val) {
      if (val === 1) {
        return 'Online'
      } else {
        return 'Offline'
      }
    },
    tokostatustext (val) {
      if (val === 1) {
        return 'Buka'
      } else {
        return 'Tutup'
      }
    }
  }
}
</script>

<style scoped>

.logo-seller {
  border-radius: 10px;
}

.profile {
  height: 250px;
  background: linear-gradient(to right, #308521 , yellow);
}
.pull-right {
  float: right;
}
.label-buka {
  float: right;
  position: relative;
  right: 12px;
  top: 190px;
}
.label-online {
  float: right;
  position: relative;
  right: -150px;
  z-index: 1;
  top: 10px;
}
.box2 {
  position: relative;
  z-index: 1;
  width: 100%;
  padding: 5px 20px;
  margin: 0 auto;
  border: 1px solid rgb(200, 200, 200);
  background: scroll;
  border-radius: 4px;
}
.box2 h3 {
  position:relative;
  padding:0 70px;
  margin:0 -30px 1px;
  font-size:16px;
  line-height:32px;
  font-weight:bold;
  text-align:center;
  color:#fff;
  background:#079c07;
  text-shadow:0 1px 1px rgba(0,0,0,0.2);
  -webkit-box-shadow:0 1px 1px rgba(0,0,0,0.2);
  -moz-box-shadow:0 1px 1px rgba(0,0,0,0.2);
  box-shadow:0 1px 1px rgba(0,0,0,0.2);
  zoom:1;
}
.box2 h3:before,
.box2 h3:after {
  content:"";
  position:absolute;
  /* See "NOTE 2" */
  z-index:-1;
  top:100%;
  left:0;
  border-width:0 10px 10px 0;
  border-style:solid;
  border-color:transparent darkgreen;
}

.box2 h3:after {
  left:auto;
  right:0;
  border-width:0 0 10px 10px;
}

.box1 {
  /* See "NOTE 3" */
  position:relative;
  z-index:1;
  width:100%;
  padding:5px 20px;
  margin:0px auto;
  border: 1px solid rgb(200, 200, 200);
  box-shadow: rgba(0, 0, 0, 0.1) 0px 5px 5px 2px;
  background:  #E4C054;
  border-radius: 4px;
}

.box1 h3 {
  position:relative;
  padding:0px 70px;
  margin:0 -30px 1px;
  font-size:16px;
  line-height:32px;
  font-weight:bold;
  text-align:center;
  color:#fff;
  background:#cc0000;
  /* css3 extras */
  text-shadow:0 1px 1px rgba(0,0,0,0.2);
  -webkit-box-shadow:0 1px 1px rgba(0,0,0,0.2);
  -moz-box-shadow:0 1px 1px rgba(0,0,0,0.2);
  box-shadow:0 1px 1px rgba(0,0,0,0.2);
  /* See "NOTE 1" */
  zoom:1;
}

.box1 h3:before,
.box1 h3:after {
  content:"";
  position:absolute;
  /* See "NOTE 2" */
  z-index:-1;
  top:100%;
  left:0;
  border-width:0 10px 10px 0;
  border-style:solid;
  border-color:transparent maroon;
}

.box1 h3:after {
  left:auto;
  right:0;
  border-width:0 0 10px 10px;
}

.boxoffline {
  position:relative;
  z-index:1;
  float: left;
  width:100%;
  padding:2px 10px;
  margin:0px auto;
  border: 1px solid rgb(200, 200, 200);
  background:  #cccccc;
  border-radius: 4px;
}

.boxoffline h3 {
  position:relative;
  padding:0px 70px;
  margin:0 -30px 1px;
  font-size:16px;
  line-height:32px;
  font-weight:bold;
  text-align:center;
  color:#2e3147;
  background:#cccccc;
  /* css3 extras */
  text-shadow:0 1px 1px rgba(0,0,0,0.2);
  -webkit-box-shadow:0 1px 1px rgba(0,0,0,0.2);
  -moz-box-shadow:0 1px 1px rgba(0,0,0,0.2);
  box-shadow:0 1px 1px rgba(0,0,0,0.2);
  /* See "NOTE 1" */
  zoom:1;
}

.boxoffline h3:before,
.boxoffline h3:after {
  content:"";
  position:absolute;
  /* See "NOTE 2" */
  z-index:-1;
  top:100%;
  left:0;
  border-width:0 10px 10px 0;
  border-style:solid;
  border-color:transparent maroon;
}

.boxoffline h3:after {
  left:auto;
  right:0;
  border-width:0 0 10px 10px;
}

.boxonline {
  position:relative;
  z-index:1;
  float: left;
  width:100%;
  padding:2px 10px;
  margin:0px auto;
  border: 1px solid #079c07;
  background:  #079c07;
  border-radius: 4px;
}

.boxonline h3 {
  position:relative;
  padding:0px 70px;
  margin:0 -30px 1px;
  font-size:16px;
  line-height:32px;
  font-weight:bold;
  text-align:center;
  color:#2e3147;
  background:#cccccc;
  /* css3 extras */
  text-shadow:0 1px 1px rgba(0,0,0,0.2);
  -webkit-box-shadow:0 1px 1px rgba(0,0,0,0.2);
  -moz-box-shadow:0 1px 1px rgba(0,0,0,0.2);
  box-shadow:0 1px 1px rgba(0,0,0,0.2);
  /* See "NOTE 1" */
  zoom:1;
}

.boxonline h3:before,
.boxonline h3:after {
  content:"";
  position:absolute;
  /* See "NOTE 2" */
  z-index:-1;
  top:100%;
  left:0;
  border-width:0 10px 10px 0;
  border-style:solid;
  border-color:transparent maroon;
}

.boxonline h3:after {
  left:auto;
  right:0;
  border-width:0 0 10px 10px;
}
</style>
